import React from 'react'
import useFetchList from '../../../elements/Hooks/useFetchList'
import { Devices as api } from '../../../api/People/Devices'
import CustomTable from '../../../elements/Table/CustomTable'
import useModalData, { MODAL_TYPE_EDIT } from '../../../elements/Hooks/useModalData'
import { Breadcrumb, Button, Card, Layout, Modal, Row, Tabs } from 'antd'
import FooterButtons from '../../../elements/Buttons/FooterButtons'
import DeviceForm from '../../../components/People/Devices/DevicesForm'
import StatusCell from '../../../elements/Table/Cells/StatusCell'
import PageTitle from '../../../elements/PageTitle'
import Documents from '../../../components/Common/Documents/DocumentsCont'
import History from '../../../components/Common/History'
import DateCell from '../../../elements/Table/Cells/DateCell'

const { Content } = Layout
const { TabPane } = Tabs

function Devices (props) {
  const { fetch, fetching, list } = useFetchList(api.list)
  const {
    visible,
    modalType,
    object: device,
    submitting,
    removing,
    formRef,
    onShow,
    onCancel,
    submit,
    update,
    remove,
    isNew,
  } = useModalData(api.create, api.update, api.remove, fetch)

  const columns = [
    {
      Header: 'ID',
      accessor: '_key',
      Cell: ({ value, original }) => (
        <a onClick={() => onShow(original, 'edit')}>{value}</a>
      ),
    },

    {
      Header: 'Name',
      accessor: 'name',
    },
    {
      Header: 'Date',
      accessor: 'date',
      Cell: DateCell,
    },
    { Header: 'Assigned To', accessor: 'assignment.to.fn' },
    { Header: 'Assignment Date', accessor: 'assignment.date', Cell: DateCell },
    { Header: 'Status', accessor: 'status', Cell: StatusCell },
  ]

  return (
    <>
      <Content style={{ margin: '0px 0px' }}>
        <Card>
          <Row>
            <Breadcrumb>
              <Breadcrumb.Item href="/people/dashboard">People</Breadcrumb.Item>
              <Breadcrumb.Item>Devices</Breadcrumb.Item>
            </Breadcrumb>
            <PageTitle
              title={'Devices'}
              subtitle={'Devices'}
              color={'#427035'}
              iconType={'laptop'}
            />
          </Row>
        </Card>
        <Row gutter={16} style={{ padding: 10 }}>
          <Card>
            <Modal
              visible={visible}
              title={'Device'}
              onCancel={onCancel}
              destroyOnClose={true}
              footer={
                <FooterButtons
                  remove={remove}
                  removing={removing}
                  submit={submit}
                  update={update}
                  submitting={submitting}
                  title={'Device'}
                  isNew={isNew}
                  isEdit={!isNew}
                />
              }
              width={'75%'}>
              <Tabs defaultActiveKey="form">
                <TabPane tab="Details" key="form">
                  <Row>
                    <DeviceForm ref={formRef} device={device}/>
                  </Row>
                </TabPane>
                <TabPane
                  disabled={modalType !== 'edit'}
                  tab="Files"
                  key="files">
                  <Documents
                    key={device._rev}
                    editable={true}
                    footer={false}
                    category={false}
                    owner={device}
                  />
                </TabPane>
                <TabPane
                  disabled={modalType !== MODAL_TYPE_EDIT}
                  tab="History"
                  key="history">
                  <History owner={device} key={device._rev} isArray={true}/>
                </TabPane>
              </Tabs>
            </Modal>
            <CustomTable
              defaultPageSize={20}
              CreateButton={() => (
                <Button
                  type={'primary'}
                  size="small"
                  icon={'plus'}
                  onClick={onShow}>
                  New{' '}
                </Button>
              )}
              columns={columns}
              fetch={fetch}
              data={list}
              fetching={fetching}
              isFilterable={true}
            />
          </Card>
        </Row>
      </Content>
    </>
  )
}

Devices.propTypes = {}
Devices.defaultProps = {}

export default Devices
